import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'

class SearchProductsService {
    Search = async (filters) => {
        const queryString = utils.GetQueryStringsFromObject(filters)
        return await HttpClient.Get(`/api/searchProducts/search?${queryString}`);
    }

    Export = async (filters) => {
        const queryString = utils.GetQueryStringsFromObject(filters)
        return await HttpClient.GetFile(`/api/searchProducts/export?${queryString}`);
    }
}

export default new SearchProductsService();